import { RESET_DATA_REDUX, SAVE_DATA_REDUX } from '../contants';

export const saveDataToStore = (data: Partial<{ [key: string]: any }>) => {
  return {
    type: SAVE_DATA_REDUX,
    payload: data,
  };
};

export const resetStoreValue = (data: { key: string }) => {
  return {
    type: RESET_DATA_REDUX,
    payload: data,
  };
};
